"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbDialog = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var Spinner_1 = __importDefault(require("./Spinner"));
var buttonBaseStyle = {
    padding: '10px 20px',
    fontFamily: 'Montserrat',
    borderRadius: 5
};
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        root: {
            height: function (_a) {
                var large = _a.large, height = _a.height;
                return height !== null && height !== void 0 ? height : (large ? '720px' : 'auto');
            },
            width: function (_a) {
                var large = _a.large, width = _a.width;
                return width !== null && width !== void 0 ? width : (large ? 1280 : 450);
            },
            maxWidth: function (_a) {
                var large = _a.large;
                return (large ? '95vw' : '95vw');
            },
            minHeight: function (_a) {
                var large = _a.large;
                return (large ? '' : '200px');
            },
            padding: function (_a) {
                var large = _a.large;
                return (large ? 36 : '20px 25px');
            },
            display: 'flex'
        },
        content: {
            padding: 0,
            fontFamily: 'Montserrat'
        },
        title: {
            padding: 0,
            marginBottom: 10,
            marginTop: function (_a) {
                var large = _a.large;
                return (large ? 15 : 0);
            },
            '& .MuiTypography-h6': {
                fontFamily: 'Montserrat',
                fontSize: '28px',
                color: function (_a) {
                    var color = _a.color;
                    return color;
                }
            }
        },
        actions: {
            marginTop: 'auto',
            padding: 0,
            '& .MuiButtonBase-root': {
                marginLeft: 10
            }
        },
        spinnerContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        buttonCancel: __assign(__assign({}, buttonBaseStyle), { color: function (_a) {
                var color = _a.color;
                return color;
            } }),
        buttonFill: __assign(__assign({}, buttonBaseStyle), { backgroundColor: function (_a) {
                var color = _a.color;
                return color;
            }, color: 'white', '&.MuiButtonBase-root.Mui-disabled': {
                backgroundColor: 'rgb(214 214 214)'
            } }),
        buttonOutline: __assign(__assign({}, buttonBaseStyle), { border: function (_a) {
                var color = _a.color;
                return "1px solid " + (color !== null && color !== void 0 ? color : '');
            }, borderRadius: 5, color: function (_a) {
                var color = _a.color;
                return color;
            } })
    });
});
var TbDialog = function (_a) {
    var large = _a.large, open = _a.open, handleClose = _a.handleClose, handleSubmit = _a.handleSubmit, closeButton = _a.closeButton, submitButton = _a.submitButton, title = _a.title, message = _a.message, children = _a.children, loading = _a.loading, props = __rest(_a, ["large", "open", "handleClose", "handleSubmit", "closeButton", "submitButton", "title", "message", "children", "loading"]);
    var classes = useStyles(__assign(__assign({}, props), { large: large }));
    var content = children;
    if (loading) {
        content = (react_1.default.createElement("div", { className: classes.spinnerContainer },
            react_1.default.createElement(Spinner_1.default, { "aria-label": 'Loading Spinner', color: props.color, style: {
                    position: 'absolute',
                    margin: 'auto',
                    width: 100,
                    height: 100
                } })));
    }
    return (react_1.default.createElement(core_1.Dialog, __assign({ classes: { paper: classes.root }, open: open, onClose: handleClose, "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description', maxWidth: large ? 'lg' : 'sm' }, props), content !== null && content !== void 0 ? content : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.DialogTitle, { className: classes.title }, title),
        react_1.default.createElement(core_1.DialogContent, { className: classes.content },
            react_1.default.createElement(core_1.DialogContentText, null, message)))),
        react_1.default.createElement(core_1.DialogActions, { className: classes.actions },
            closeButton && (react_1.default.createElement(core_1.ButtonBase, { "aria-label": 'Close Dialog', onClick: handleClose, className: !submitButton ? classes.buttonOutline : classes.buttonCancel }, closeButton)),
            submitButton && (react_1.default.createElement(core_1.ButtonBase, { "aria-label": 'Submit Dialog', disabled: loading, onClick: handleSubmit, className: classes.buttonFill }, submitButton)))));
};
exports.TbDialog = TbDialog;
//# sourceMappingURL=TbDialog.js.map